'use strict';
(function($){
	/*
	 * Vetology.Ratings widget
	 *
	 * @description Adds rating for actions/pages or other things in the platform front end
	 *
	 * @options					See description for each option
	 * @options canvas			The canvas descriptor where things wil be drawned
	 *							image_viewer
	 *								container	The main container of the canvas
	 *								canvas		The actual canvas where the images are rendered
	 *							image_diagnosys
	 *								original The details of the image of the study
	 *									container	The main container of the canvas
	 *									canvas		The actual canvas where the images are rendered
	 *								compare The details of the image that the study is being compared against
	 *									container	The main container of the canvas
	 *									canvas		The actual canvas where the images are rendered
	 * 							layout The format in which images are displayed values are 0 for side by side, 1 for one on top of the other
	 * @options ratio			The ratio of width/height that should be used the images will always use full width of the calculated space and the height will always be the width * ratio
	 * @options body_loading	A class name to add to the body when anything is loading
	 * @options tools			The selectors for the buttons that control the enabled tool/effect/interface
	 * @options interfaces		The selectors for the containers where an interface is located 
	 *							interfaces.global is a class that every interface contains so they can all be disabled
	 *							interfaces.image_over is a class that will be used to trigger the event handlers on the images
	 *
	 * @method	See description above each method
	 */
	$.widget(
		'Vetology.Ratings',
		{
			"options": {
				"allowFeedback": true,
				"rating": 0
			},
			/*
			 * Vetology.Ratings._init
			 *
			 * @description	Initializes toolset behavior behavior
			 *
			 * @return NULL
			 *
			 */
			"_init": function(){
				var o = this;
				o.options.rating = o.element.data("rating");
				o.options.url = o.element.data("url");
				o.options.allowFeedback = o.element.data("allowfeedback");
				o.options.update_rating = typeof o.element.data("update_rating") != "undefined" ? o.element.data("update_rating") : false;
				o.options.feedback = o.element.data("feedback");
				o.options.feedback_field = typeof o.element.data("feedback_field") != "undefined" ? o.element.data("feedback_field") : "feedback";
				o.options.feedbackplaceholder = typeof o.element.data("placeholder") != "undefined" ? o.element.data("placeholder") : "Please enter your feedback here";
				o.options.feedbacksubmit = typeof o.element.data("feedbacksubmit") != "undefined" ? o.element.data("feedbacksubmit") : "Submit feedback";
				var html = o._getHtml();
				o.element.append(html);
				o._initEvents();

			},
			"_initEvents": function(){
				var o = this;
				o.element.on("mouseenter", ".stars_block_inner a", function(){
					o._updateStars($(this).data("rating"));
				});
				o.element.on("click", ".stars_block_inner a", function(){
					var el = $(this);
					o.options.rating = el.data("rating");
					o._updateStars(o.options.rating);
					if(el.closest("li.page-rating").length > 0){
						el.closest("li.page-rating").addClass("keepOpen");
						setTimeout(
							function(){
								el.closest("li.page-rating").removeClass("keepOpen").addClass("open");
							}, 100
						);
					}
				});
				o.element.on("mouseleave", ".stars_block_inner", function(){
					o._updateStars(o.options.rating);
				});
				o.element.on("click", ".send_rating", function(){
					o._sendRating();
				});
			},
			"_sendRating": function(){
				var o = this;
				var data = {
					"rating": o.options.rating,
				};
				data[o.options.feedback_field] = o.element.find(".feedback_text").val();
				$("body").Vetology("vetologyLoadStart", "Please wait while we send your rating...");
				$.ajax(
					{
						type: 'POST', 
						url: o.options.url, 
						data: data,
						dataType: 'JSON',
						success: function (data){
							if(o.options.update_rating != false){
								$(o.options.update_rating).html(o.options.rating.toFixed(1));
							}
							o.element.find(".label").remove();
							o.element.append('<span class="label label-success">Thank you for your rating.</span>');
							setTimeout(
								function(){
									o.element.find(".label").remove();
								},
								10000
							);
							$("body").Vetology("vetologyLoadEnd");
						}
					}
				);
			},
			"_updateStars": function(rating){
				var o = this;
				var className = o._getRatingClass(rating);
				o.element.find(".stars_block_inner").attr("class", className);
			},
			"_getRatingClass": function(rating){
				var o = this;
				var className = 'stars_block_inner ';
				if($.inArray(rating, [0.5, 1.5, 2.5, 3.5, 4.5]) > -1){
					if(o.options.update_rating != false){
						$(o.options.update_rating).html(rating.toFixed(1));
					}
					className += ('stars_block_' + rating.toFixed(1)).replace('.', '_');
				} else if($.inArray(rating, [1.0, 2.0, 3.0, 4.0, 5.0]) > -1){
					if(o.options.update_rating != false){
						$(o.options.update_rating).html(rating.toFixed(0));
					}
					className += ('stars_block_' + rating.toFixed(1)).replace('.', '_');
				}
				return className;
			},
			"_getHtml": function(){
				var o = this;
				var className = o._getRatingClass(o.options.rating);
				var html = '<div class="stars_block">';
				html += '<div class="' + className + '">';
				var ratings = 0.5;
				var stars = 1;
				while(stars < 6){
					html += '<div class="star_block star_' + stars + '">';
					html += '<a href="#" class="vetology_pd star_left" data-rating="' + ratings + '"></a>';
					ratings += .5;
					html += '<a href="#" class="vetology_pd star_right" data-rating="' + ratings + '"></a>';
					ratings += .5;
					html += '<span class="vetology-rating-star"><span class="sleft"></span><span class="sright"></span></span>';
					html += '<span class="vetology-rating-star star_static"><span class="sleft"></span><span class="sright"></span></span>';
					html += '</div>';
					stars ++;
				}
				html += '</div>';
				if(o.options.allowFeedback){
					html += '<div class="feedback_area">';
					html += '<textarea class="form-control feedback_text" placeholder="' + o.options.feedbackplaceholder + '">' + o.options.feedback + '</textarea>';
					html += '</div>';
				}
				html += '<a href="#" class="vetology_pd send_rating btn btn-xs btn input-block-level btn-primary pull-right">' + o.options.feedbacksubmit + '</a>';
				html += '</div>';
				return html;
			}
		}
	);
})(jQuery);